import { StarIcon } from "@src/assets";
import { Skeleton } from "@src/components";
import { AnimatedNumber } from "@src/components/AnimatedNumber";
import { SWAPPER_FINANCE_URL } from "@src/config";
import { useRewards } from "@src/contexts";

export const RewardsSummaryCards = () => {
  const { points, loadingState } = useRewards();
  return (
    <div className="flex flex-col">
      <div className="px-4 py-3 flex flex-col items-center justify-between rounded-[12px] bg-card_bg">
        <p className="text-sm font-medium text-text_primary/60">Your points</p>
        <div className="flex gap-1 items-center justify-center">
          {loadingState.points ? (
            <Skeleton className="w-24 h-8" />
          ) : (
            <p className="text-text_primary font-bold text-2xl">
              <AnimatedNumber
                from={points.prevStats.points}
                to={points.stats.points}
              />
            </p>
          )}
          <StarIcon />
        </div>
      </div>
      <p className="text-sm text-text_primary/60 text-center p-4">
        Gain more points by trading with Swapper, inviting friends
        to&nbsp;do&nbsp;the same and completing tasks.{" "}
        <a
          className="text-theme_color"
          target="_blank"
          href={`${SWAPPER_FINANCE_URL}/rewards`}
        >
          Learn&nbsp;more&nbsp;&gt;
        </a>
      </p>
    </div>
  );
};
